import { BaseModel } from '../base/base.model';

export class PatchBluePrintRootPayload extends BaseModel {
  constructor(
    public id: string,
    public name: string,
    public description: string,
    public createdDate: string,
    public modifiedDate: string,
    public createdBy: string,
    public modifiedBy: string,
    public isArchived: boolean,
    public parent: string,
  ) {
    super(id, name, description, createdDate, modifiedDate, createdBy, modifiedBy);
  }
}
